/**
 * Duração de sono em minutos como a tela fala: `7h05`, `45min`.
 *
 * `sleepTotalTime` chega em **minutos** do metrics: o `cinco-b2c` normaliza no upload,
 * nas duas fontes (pulseira e Health Connect) — a mesma premissa do `alertChart.ts`.
 */
const formatSleepMinutes = (minutes: number): string => {
  const total = Math.round(minutes);
  const hours = Math.floor(total / 60);
  const rest = total % 60;

  if (hours === 0) {
    return `${rest}min`;
  }

  return `${hours}h${String(rest).padStart(2, '0')}`;
};

export default formatSleepMinutes;
